export class BaseMetric {
	public static gtag: any

	public static setGtag(gtag: any) {
		this.gtag = gtag
	}
}
